import { CheckCircle2, Info, TriangleAlert, X } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useToasts } from '../../stores/toasts';

const ICONS = {
  info: <Info className="size-4 text-sky-400" />,
  success: <CheckCircle2 className="size-4 text-emerald-400" />,
  error: <TriangleAlert className="size-4 text-red-400" />,
};

export function Toaster() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div
      aria-live="polite"
      // Above the bars a board keeps along its bottom edge.
      className="pointer-events-none fixed inset-x-0 bottom-16 z-[70] flex flex-col items-center gap-2 px-4"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.tone === 'error' ? 'alert' : 'status'}
          className={cn(
            'pointer-events-auto flex max-w-md items-center gap-3 rounded-xl bg-slate-900 py-2.5 pr-2 pl-4 text-sm text-white shadow-float animate-pop-in dark:bg-slate-800',
          )}
        >
          {ICONS[t.tone]}
          <span className="flex-1">{t.message}</span>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            className="rounded-md p-1 text-slate-400 hover:bg-white/10 hover:text-white"
            aria-label="Dismiss"
          >
            <X className="size-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
